
import { useEffect } from "react";
import TopSpace from "../../components/TopSpace";
import BannerShort from "../../components/banners/BannerShort";
import { serviceObject } from "../../providers/GlobalObjects";
import ServiceClient from "./ServiceClient";
import { useParams } from "react-router-dom";
import EmptyState from "../../components/EmptyState";

const ServiceDetails = () => {
    const params = useParams();

    const service = serviceObject.find(item => item.slug === params.slug);

    if(!service){
      return (
        <EmptyState 
          message={'No records have been added yet.'}
        />
      )
    }


    // const getService = async () => {
        
    // }
    
    
    // getService();

    return (
        <TopSpace>
          <BannerShort 
            heading={service.title}
            description={service.description}
            bgImage={'/banner/review-banner.jpg'}
          />
          <ServiceClient 
                slug={params.id}
          />
        </TopSpace>
    );
};

export default ServiceDetails;